/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ErrorEnterprise.vue?vue&type=template&id=b2aaf994&scoped=true&"
import script from "./ErrorEnterprise.vue?vue&type=script&lang=js&"
export * from "./ErrorEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./ErrorEnterprise.vue?vue&type=style&index=0&id=b2aaf994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aaf994",
  null
  
)

export default component.exports